import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-simple-input',
    templateUrl: './simple-input.component.html',
    styleUrls: ['./simple-input.component.scss'],
    standalone: false
})
export class SimpleInputComponent implements OnInit {
  @Input() data: string;
  @Input() disabledFlag: boolean;
  @Input() label: string = "";
  @Input() placeholder: string = "";
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
  @Output() keyUp: EventEmitter<string> = new EventEmitter<string>();

  tempValue: any;

  constructor() {}

  ngOnInit() {}

  onFocusOut() {
    this.focusOut.emit(this.data);
  }
  onKeyUp() {
    this.keyUp.emit(this.data);
  }

  startEdit() {
    this.tempValue = this.data;
  }

  undo() {
    this.data = this.tempValue;
  }
}
